<template lang="html">
  <section class="service-part box">
    <h2>服务项目</h2>
    <div class="margin-scroll">
      <ul>
        <li v-for="(l, index) in list">
          <a
            :href="`/v/product/${
              l.spuId
            }?empid=${empId}&refresh=no&hserecomkey=${
              $route.query.hserecomkey || ''
            }`"
            class="link-info"
            @click="trackClick(200002, '', '', 121011912, `${index + 1}`)"
          >
            <img
              :src="
                l.cmmdtyImage ||
                'https://hzwimspic-1251601690.picsh.myqcloud.com/1b41f840-56e1-11ea-a92c-d30c8fbccdfb_size_375x225'
              "
            />
            <p class="block-name ui-nowrap-multi">{{ l.spuName }}</p>
            <span class="btn btn-order-store" v-if="l.minPrice === l.maxPrice"
              >&yen;{{ l.minPrice | priceNum }}</span
            >
            <span class="btn btn-order-store" v-else
              >&yen;{{ l.minPrice | priceNum }}~&yen;{{
                l.maxPrice | priceNum
              }}</span
            >
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  PAGE_ID: '288991',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    empId: {
      type: [Number, String],
      default: ''
    }
  },
  methods: {
    serviceShowTrigger(e) {
      const iel = e.currentTarget.querySelector('i')
      iel.classList.toggle('rotate')
      document
        .querySelector('.service-part li.addborder')
        .classList.toggle('withborder')
      const els = [...document.querySelectorAll('.service-part li.needHide')]
      els.forEach(el => {
        el.classList.toggle('hide')
      })
    }
  }
}
</script>

<style lang="scss" scoped="">
@import '../../assets/css/mixin';
.service-part {
  background: #ffffff;
  padding: 0 rem(25px);
  margin-bottom: rem(20px);
  .margin-scroll {
    margin: 0 rem(-30px);
  }
  h2 {
    font-weight: bold;
  }
  ul {
    display: -webkit-box;
    width: 100%;
    margin-top: rem(30px);
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    padding-left: rem(30px);
    li {
      margin-right: rem(20px);
      box-sizing: border-box;
      overflow: hidden;
      &:last-child {
        padding-right: rem(30px);
      }
      a {
        display: flex;
        flex-direction: column;
        align-items: left;
        flex: 1;
        width: rem(250px);
        img {
          width: rem(250px);
          height: rem(150px);
          border-radius: rem(4px);
        }
      }
      .block-name {
        margin-top: rem(16px);
        font-size: rem(28px);
        color: #121212;
      }
      .ui-nowrap-multi {
        -webkit-line-clamp: 1;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
      }
    }
  }
  .btn {
    display: inline-block;
    margin-top: rem(10px);
    margin-bottom: rem(15px);
    font-size: rem(28px);
    color: #ff397e;
    transition: all 200ms;
    i {
      display: block;
      color: #999999;
    }
    .rotate {
      transform: rotate(180deg);
    }
  }
  .active {
    transform: rotate(-180deg);
  }
}
</style>
